
import './App.css';
import RoutesPath from './Routes/Routes';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context"
import { message } from 'antd';
const errorLink = onError(({ graphqlErrors, networkError }) => {
  if (graphqlErrors) {
    graphqlErrors.map(({ message, location, path }) => {
      alert(`Graphql error ${message}`);
    });
  }
});
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("shub-sm-token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});
const link = from([
  errorLink,
  new HttpLink({ uri: process.env.REACT_APP_URI }),
]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(link),

});

function App() {
  const [messageApi, contextHolder] = message.useMessage();
  console.log("LOCATION IS", window.location.protocol);
  return (
    <ApolloProvider client={client}>
      {contextHolder}
      <RoutesPath />
    </ApolloProvider>
  );
}

export default App;





